import React from 'react'
import PayCard from '../../../components/comment/paymentCard/paymentCard'

const addeddetail = () => {
  return (
    <div className="add-detail-wrap">
   
    <div className="rightbar-title">
        Added net banking details 
    </div>
    
    <div className='saved-card-wrap'>
        <PayCard />
    </div>

    </div>
  )
}

export default addeddetail